<mat-toolbar>
  <button type="button" mat-icon-button (click)="menuClick.emit()">
    <mat-icon>menu</mat-icon>
  </button>
  <span>{{ title }}</span>
</mat-toolbar>
